export default __webpack_public_path__ + "menu-translation-icon.77a2c805576b0c0ae937fd2501c9371c.svg";